import { VerifyEmailRequest, VerifyEmailResponse } from '../models/requests/VerifyEmailRequest';

class RCUIClient {
  rmUrl = process.env.REACT_APP_RM_URL;
  raceOSUrl = process.env.REACT_APP_RACEOS_URL;

  constructor() {
    if (!this.rmUrl) {
      throw new Error('REACT_APP_RM_URL is not defined');
    }
    if (!this.raceOSUrl) {
      throw new Error('REACT_APP_RACEOS_URL is not defined');
    }
  }

  async verifyEmail(request: VerifyEmailRequest): Promise<VerifyEmailResponse>
  {
    if (request.game === 'lmu') {
      return this.verifyEmailViaRaceOS(request);
    } else if (request.game === 'rf2') {
      return this.verifyEmailViaRaceManagement(request);
    } else {
      throw new Error(`Unknown game: ${request.game}`);
    }
  }

  private async verifyEmailViaRaceManagement(request: VerifyEmailRequest): Promise<VerifyEmailResponse>
  {
    const response = await fetch(`${this.rmUrl}/rcui/email/verify`,
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ...request, uuid: atob(request.uuid) })
    });

    const body = await response?.text();

    try
    {
      return JSON.parse(body) as VerifyEmailResponse;
    } catch (error)
    {
      return {Status: response.status.toString(), Message: body} as VerifyEmailResponse;
    }
  }

  private async verifyEmailViaRaceOS(request: VerifyEmailRequest): Promise<VerifyEmailResponse>
  {
    const response = await fetch(`${this.raceOSUrl}/api/v1/player/email-verify/${encodeURIComponent(request.uuid)}`,
    {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    });

    const body = await response?.text();

    try
    {
      // RaceOS returns { id, status, message } with status "OK" on success.
      // Map it into the VerifyEmailResponse shape the UI expects.
      const raceOSResponse = JSON.parse(body) as { id?: string; status?: string; message?: string };
      const isOk = raceOSResponse.status?.toUpperCase() === "OK";

      return {
        Status: isOk ? "Success" : (raceOSResponse.status ?? response.status.toString()),
        Message: raceOSResponse.message ?? raceOSResponse.id ?? ""
      } as VerifyEmailResponse;
    } catch (error)
    {
      return {Status: response.status.toString(), Message: body} as VerifyEmailResponse;
    }
  }

}

export default RCUIClient;
